import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { orderItemRepository } from '../data-access/repositories/OrderItemRepository'

const base = ['order-item']

export const orderItemQueryConfig = {
  getPurchasingListItems: () => ({
    queryKey: buildQueryKey([...base, 'purchasing-list']),
    queryFn: () => orderItemRepository.getPurchasingListItems(),
  }),
}
